import { FC } from 'react';
import { Redirect } from 'react-router';

const HomeScreen: FC = () => {
  return <Redirect to="/clients" />;
};

export default HomeScreen;
